import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { MapStore } from '../types/map'
import { MapCenter } from '../components/features/Map/MapHelper'
import { createDebouncedJSONStorage } from 'zustand-debounce'
import indexedDbStorage from '../utils/indexeddb-zustand-store'

export const storageName = 'MOOD_map_store';

const useMapStore = create<MapStore>()(
  persist(
    (set) => ({
      viewState: {
        height: 400,
        width: 400,
        latitude: 31,
        longitude: 0,
        zoom: 1.5,
        transitionDuration: 1000,
        pitch: 0,
        bearing: 0,
      },
      setViewState: (viewState) => set({ viewState }),

      mapBoundsZoom: { bounds: [0, 0, 0, 0], zoom: 1 },
      setMapBoundsZoom: (mapBoundsZoom) => set({ mapBoundsZoom }),

      updatedBounds: true,
      setUpdatedBounds: (updatedBounds) => set({ updatedBounds }),

      dragPan: true,
      setDragPan: (dragPan) => set({ dragPan }),

      coordsMoved: false,
      setCoordsMoved: (coordsMoved) => set({ coordsMoved }),

      mapCenter: MapCenter,
      setMapCenter: (mapCenter) => set({ mapCenter }),

      reset: () => set({
        viewState: {
          height: 400,
          width: 400,
          latitude: 31,
          longitude: 0,
          zoom: 1.5,
          transitionDuration: 1000,
          pitch: 0,
          bearing: 0,
        },
        mapBoundsZoom: { bounds: [0, 0, 0, 0], zoom: 1 },
        updatedBounds: true,
        dragPan: true,
        coordsMoved: false,
        mapCenter: MapCenter,
      }),
    }),
    {
      name: storageName,
      storage: createDebouncedJSONStorage(indexedDbStorage, { debounceTime: 500 }),
      partialize: (state) => ({
        viewState: state.viewState,
      }),
    }
  )
);

export const isStoreEmpty = (state: MapStore): boolean => {
  return state.viewState.zoom >= 1.5 || state.viewState.zoom <= 1.6;
};


export default useMapStore;
